export default{
    name:'SigninImage'
}